import { render, staticRenderFns } from "./ArticleRating.vue?vue&type=template&id=456d0d5a&"
import script from "./ArticleRating.vue?vue&type=script&lang=js&"
export * from "./ArticleRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports